import { BarChart4 } from 'lucide-react';

import { ReportsView } from './views/ReportsView';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const basePath = '/reports';

export const reportsRoutes = createModuleRoutes({
  root: {
    path: basePath,
    label: (t) => t.menu.reports.root,
    icon: BarChart4,
    component: ReportsView,
  },
});

const reportsNav = createModuleNav(($) => $(reportsRoutes.root));

export const reportsModule = createAppModule({
  routes: reportsRoutes,
  nav: reportsNav,
  requiredEntitlement: 'reporting',
});
